import { render, staticRenderFns } from "./ProductTagging.vue?vue&type=template&id=638668c6&"
import script from "./ProductTagging.vue?vue&type=script&lang=js&"
export * from "./ProductTagging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports